import 'promise-polyfill/src/polyfill';
import "scroll-behavior-polyfill";

require('./assign');
require('./array.includes');
require('./forEach');
require('./CustomEvent');
require('./Proxy');
